export const getClientPackageVersion = () => (process.env.REACT_APP_TAPS5_BUILD_TAG ?? process.env.REACT_APP_ENVIRONMENT)
